import { render } from "./About.vue?vue&type=template&id=bff9c942"
const script = {}
script.render = render

export default script